export default __webpack_public_path__ + "media/WYSIWYG.9e1788ce.png";